import {
  buildCommonInsuranceContractParameters,
  ensureCorrectCommissionFormat,
} from '../buildCommonInsuranceContractParameters'

export const contractSaveParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  contactPreferences,
  action = 'save',
}) => {
  const options = buildCommonInsuranceContractParameters({
    type,
    contractId,
    contactId,
    addressId,
    contractData,
    characteristicsData,
    contactPreferences,
    action,
  })

  if (contractData.fees?.length > 0) {
    options.append('fees', ensureCorrectCommissionFormat(contractData.fees))
  }

  return options
}
